import { render, staticRenderFns } from "./PosthogEventListener.vue?vue&type=template&id=df610240"
import script from "./PosthogEventListener.vue?vue&type=script&lang=js"
export * from "./PosthogEventListener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports